'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var core = require('datastore-core');

var ShardingStore = core.ShardingDatastore;

var Block = require('ipld-block');

var _require = require('./blockstore-utils'),
    cidToKey = _require.cidToKey,
    keyToCid = _require.keyToCid;

var map = require('it-map');

var pipe = require('it-pipe');

module.exports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(filestore, options) {
    var store;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return maybeWithSharding(filestore, options);

          case 2:
            store = _context.sent;
            return _context.abrupt("return", createBaseStore(store));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

function maybeWithSharding(filestore, options) {
  if (options.sharding) {
    var shard = new core.shard.NextToLast(2);
    return ShardingStore.createOrOpen(filestore, shard);
  }

  return filestore;
}

function createBaseStore(store) {
  return {
    /**
     * Query the store.
     *
     * @param {Object} query
     * @param {Object} options
     * @returns {AsyncIterator<Block>}
     */
    query: function query(_query, options) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(store.query(_query, options)), _awaitAsyncGenerator), "t0", 1);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * Get a single block by CID.
     *
     * @param {CID} cid
     * @param {Object} options
     * @returns {Promise<Block>}
     */
    get: function get(cid, options) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var key, blockData, otherCid, otherKey, _blockData;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                key = cidToKey(cid);
                _context3.prev = 1;
                _context3.next = 4;
                return store.get(key, options);

              case 4:
                blockData = _context3.sent;
                return _context3.abrupt("return", new Block(blockData, cid));

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);

                if (!(_context3.t0.code === 'ERR_NOT_FOUND')) {
                  _context3.next = 21;
                  break;
                }

                otherCid = cidToOtherVersion(cid);

                if (otherCid) {
                  _context3.next = 14;
                  break;
                }

                throw _context3.t0;

              case 14:
                otherKey = cidToKey(otherCid);
                _context3.next = 17;
                return store.get(otherKey, options);

              case 17:
                _blockData = _context3.sent;
                _context3.next = 20;
                return store.put(key, _blockData);

              case 20:
                return _context3.abrupt("return", new Block(_blockData, cid));

              case 21:
                throw _context3.t0;

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 8]]);
      }))();
    },

    /**
     * Like get, but for more.
     *
     * @param {AsyncIterator<CID>} cids
     * @param {Object} options
     * @returns {AsyncIterator<Block>}
     */
    getMany: function getMany(cids, options) {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, cid;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context4.prev = 2;
                _iterator = _asyncIterator(cids);

              case 4:
                _context4.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                _step = _context4.sent;
                _iteratorNormalCompletion = _step.done;
                _context4.next = 10;
                return _awaitAsyncGenerator(_step.value);

              case 10:
                _value = _context4.sent;

                if (_iteratorNormalCompletion) {
                  _context4.next = 18;
                  break;
                }

                cid = _value;
                _context4.next = 15;
                return _this.get(cid, options);

              case 15:
                _iteratorNormalCompletion = true;
                _context4.next = 4;
                break;

              case 18:
                _context4.next = 24;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t0 = _context4["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 24:
                _context4.prev = 24;
                _context4.prev = 25;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context4.next = 29;
                  break;
                }

                _context4.next = 29;
                return _awaitAsyncGenerator(_iterator.return());

              case 29:
                _context4.prev = 29;

                if (!_didIteratorError) {
                  _context4.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context4.finish(29);

              case 33:
                return _context4.finish(24);

              case 34:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 20, 24, 34], [25,, 29, 33]]);
      }))();
    },

    /**
     * Write a single block to the store.
     *
     * @param {Block} block
     * @param {Object} options
     * @returns {Promise<Block>}
     */
    put: function put(block, options) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var exists;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (Block.isBlock(block)) {
                  _context5.next = 2;
                  break;
                }

                throw new Error('invalid block');

              case 2:
                _context5.next = 4;
                return _this2.has(block.cid);

              case 4:
                exists = _context5.sent;

                if (!exists) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", _this2.get(block.cid, options));

              case 7:
                _context5.next = 9;
                return store.put(cidToKey(block.cid), block.data, options);

              case 9:
                return _context5.abrupt("return", block);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },

    /**
     * Like put, but for more.
     *
     * @param {AsyncIterable<Block>|Iterable<Block>} blocks
     * @param {Object} options
     * @returns {AsyncIterable<Block>}
     */
    putMany: function putMany(blocks, options) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.delegateYield(_asyncGeneratorDelegate(_asyncIterator(pipe(blocks, function (source) {
                  // turn them into a key/value pair
                  return map(source, function (block) {
                    return {
                      key: cidToKey(block.cid),
                      value: block.data
                    };
                  });
                }, function (source) {
                  // put them into the datastore
                  return store.putMany(source, options);
                }, function (source) {
                  // map the returned key/value back into a block
                  return map(source, function (_ref3) {
                    var key = _ref3.key,
                        value = _ref3.value;
                    return new Block(value, keyToCid(key));
                  });
                })), _awaitAsyncGenerator), "t0", 1);

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },

    /**
     * Does the store contain block with this cid?
     *
     * @param {CID} cid
     * @param {Object} options
     * @returns {Promise<bool>}
     */
    has: function has(cid, options) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var exists, otherCid;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return store.has(cidToKey(cid), options);

              case 2:
                exists = _context7.sent;

                if (!exists) {
                  _context7.next = 5;
                  break;
                }

                return _context7.abrupt("return", exists);

              case 5:
                otherCid = cidToOtherVersion(cid);

                if (otherCid) {
                  _context7.next = 8;
                  break;
                }

                return _context7.abrupt("return", false);

              case 8:
                return _context7.abrupt("return", store.has(cidToKey(otherCid), options));

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },

    /**
     * Delete a block from the store
     *
     * @param {CID} cid
     * @param {Object} options
     * @returns {Promise<void>}
     */
    delete: function _delete(cid, options) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", store.delete(cidToKey(cid), options));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },

    /**
     * Delete a block from the store
     *
     * @param {AsyncIterable<CID>} cids
     * @param {Object} options
     * @returns {Promise<void>}
     */
    deleteMany: function deleteMany(cids, options) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.delegateYield(_asyncGeneratorDelegate(_asyncIterator(store.deleteMany(_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                  var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, cid;

                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _context9.prev = 2;
                          _iterator2 = _asyncIterator(cids);

                        case 4:
                          _context9.next = 6;
                          return _awaitAsyncGenerator(_iterator2.next());

                        case 6:
                          _step2 = _context9.sent;
                          _iteratorNormalCompletion2 = _step2.done;
                          _context9.next = 10;
                          return _awaitAsyncGenerator(_step2.value);

                        case 10:
                          _value2 = _context9.sent;

                          if (_iteratorNormalCompletion2) {
                            _context9.next = 18;
                            break;
                          }

                          cid = _value2;
                          _context9.next = 15;
                          return cidToKey(cid);

                        case 15:
                          _iteratorNormalCompletion2 = true;
                          _context9.next = 4;
                          break;

                        case 18:
                          _context9.next = 24;
                          break;

                        case 20:
                          _context9.prev = 20;
                          _context9.t0 = _context9["catch"](2);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context9.t0;

                        case 24:
                          _context9.prev = 24;
                          _context9.prev = 25;

                          if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                            _context9.next = 29;
                            break;
                          }

                          _context9.next = 29;
                          return _awaitAsyncGenerator(_iterator2.return());

                        case 29:
                          _context9.prev = 29;

                          if (!_didIteratorError2) {
                            _context9.next = 32;
                            break;
                          }

                          throw _iteratorError2;

                        case 32:
                          return _context9.finish(29);

                        case 33:
                          return _context9.finish(24);

                        case 34:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9, null, [[2, 20, 24, 34], [25,, 29, 33]]);
                }))(), options)), _awaitAsyncGenerator), "t0", 1);

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },

    /**
     * Close the store
     *
     * @returns {Promise<void>}
     */
    close: function close() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", store.close());

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    }
  };
}

function cidToOtherVersion(cid) {
  try {
    return cid.version === 0 ? cid.toV1() : cid.toV0();
  } catch (err) {
    return null;
  }
}